import { SCORE_LEVEL } from "./verdict";

// Résumé partageable : verdict + 3 dimensions + nombre de faiblesses.
// Jamais le mot de passe, sa longueur, ses segments ni les types de motifs.
export const verdictShareText = (t, { verdict, score, breachStatus, patternCount, url }) => t("share.text", {
  verdict: t(`verdict.${verdict}`),
  resistance: t(`verdict.${SCORE_LEVEL[score]}`),
  exposure: t(`summary.exposureState.${breachStatus}`),
  patterns: patternCount ? t("summary.countPatterns", { count: patternCount }) : t("summary.noMajor"),
  url,
});
